<!--
 * @Description: 拖动值容器
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2021-06-01 13:52:02
 * @LastEditors: jinchuan.lee
 * @LastEditTime: 2021-06-10 18:11:16
-->
<template>
    <transition name="el-fade-in-linear">
        <div class="c-settingField" v-show = "isSettingFieldShow" @mouseleave = "settingFieldLeave" @mouseenter = "settingFieldEnter">
            <div class="c-settingField-row">
                <div class="c-settingField-row-left c-settingField-row-aiwrapper">
                    <transition name="el-fade-in-linear">
                        <canvasBg ref = "canvasBgRef" v-show = "showAiThink"></canvasBg>
                    </transition>
                    <div class="c-settingField-row-aiwrapper-content">
                        <el-tooltip 
                            :content="aiContent" 
                            placement="top" 
                            effect="light" 
                            popper-class = "c-settingField-aiSay"
                            v-model = "isAiSay"
                        >
                            <img
                            src="/static/img/AI-running.png"
                            class="c-settingField-row-aiwrapper-AI"
                            alt=""
                            @mouseenter="getAiSay"
                            >
                        </el-tooltip>
                    </div>
                </div>
                <!-- 列 -->
                <div class="c-settingField-row-right c-settingField-columns pd15">
                    <drag-list 
                        id="columnList" 
                        @change = "handleChange" 
                        @selectChange = "handleSelectChange"
                        ref = "columnDom"
                        @itemHold = "handleItemHold" 
                        :isSettingFieldShow="isSettingFieldShow"
                        :dateList = "dateList"
                        :numberList = "numberList"
                    >
                    </drag-list>
                    <!-- 中间描述 -->
                    <div class="c-settingField-describe">
                        <div class="center color333 size20 bold">列</div>
                        <div class="color666">例如：产品/收入类型/报销类型</div>
                    </div>
                    <!-- 遮罩层 防止添加 -->
                    <div class="c-settingField-preventModel" v-show="isShowColumnModel"><span>{{ columnModelText }}</span></div>
                </div>
            </div>
            <div class="c-settingField-row">
                <!-- 行 -->
                <div class="c-settingField-row-left c-settingField-rows pd15">
                    <drag-list 
                        id="rowList" 
                        @change = "handleChange" 
                        @itemHold = "handleItemHold" 
                        ref = "rowDom" 
                        @selectChange = "handleSelectChange"
                        :isSettingFieldShow="isSettingFieldShow"
                        :dateList = "dateList"
                        :numberList = "numberList"
                    >
                    </drag-list>
                    <!-- 中间描述 -->
                    <div class="c-settingField-describe">
                        <div class="center color333 size20 bold">行</div>
                        <div class="color666" style="white-space:nowrap">例如：日期/摘要/销售/部门</div>
                    </div>
                    <!-- 遮罩层 防止添加 -->
                    <div class="c-settingField-preventModel" v-show="isShowRowModel"><span>{{ rowModelText }}</span></div>
                </div>
                <!-- 值 -->
                <div class="c-settingField-row-right c-settingField-values pd15">
                    <drag-list 
                        id="valueList" 
                        @change = "handleChange" 
                        ref = "valueDom" 
                        @selectChange = "handleSelectChange"
                        @itemHold = "handleItemHold" 
                        :isSettingFieldShow="isSettingFieldShow"
                        :dateList = "dateList"
                        :numberList = "numberList"
                    >
                    </drag-list>
                    <!-- 中间描述 -->
                    <div class="c-settingField-describe">
                        <div class="center color333 size20 bold">交叉分析值</div>
                        <div class="color666">收入/支出/应收/尾款（合计） 或 销售产品（计数）</div>
                    </div>
                    <!-- 遮罩层 防止添加 -->
                    <div class="c-settingField-preventModel" v-show="isShowValueModel"><span>{{ valueModelText }}</span></div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import dragList from "./dragList"
import canvasBg from "./canvas-bg"
export default {
    components:{
        dragList,
        canvasBg
    },
    props: {
        holdData:Object,
    },
    data() {
        return {  
            showAiThink: false,  // 是否展示ai思考动画
            canvasBgTime:null,
            isAiSay: false,
            isStop:false,  // 阻止系统自动关闭当前页
            isShowColumnModel:false, // 是否显示列遮罩层     
            isShowRowModel:false, // 是否显示行遮罩层     
            isShowValueModel:false, // 是否显示值遮罩层     
            columnModelText: "",  // 列提示文本
            rowModelText: "",  // 行提示文本
            valueModelText: "",  // 值列文本
            columnList: [],
            rowList: [],
            valueList: [],
            isHoldTime: false,  // 是否按住鼠标
            isSettingFieldShow:false,   // 是否显示拖动区域
            dateList:[],  // 日期下拉值
            numberList:[], // 数值下拉值
            fadeTime:null, // 显示计时器
            closeTime:null, // 悬停关闭显示计时器
            _AiSay: [],  // 语言备份
            AiSay:[
                "拖动分析对象到这里试试看！",
                "小A帮你计算计算~",
                "配置后记得保存报表哟！",
                "点击空白处马上查看分析结果！",
                "2秒钟不动我就要帮你分析了哟",
                "时间范围内有数据才可分析哟~",
                "想要分析更全面，多增加字段试试",
                "分析日期可以设置按年/月/日哟",
                "分析数值可以求和哟",
                "分析数值可以按最大值哟",
                "分析数值可以按最小值哟",
                "交叉分析值分析文本字段仅计数哟",
                "不同统计维度建议多建几张报表",
            ],
            aiContent:""
        }
    },
    watch: {
        holdData(data) {
            this.handleItemHold(data);
        },
        isSettingFieldShow(val) {
            if(val) {
                this.getFirstGoin();
                this.$nextTick(()=>{
                    this.$refs.canvasBgRef.getWindowSize();
                })
            }else {
                this.isAiSay = false;
            }
            this.$emit("fieldShowChange",val);
        }
    },
    deactivated () {
        this.addWindClick(false);
    },
    activated() {
        this.addWindClick(true);
    },
    created() {
        this.getDictionaries();
        this._AiSay = this.$lodash.cloneDeep(this.AiSay);  // 赋值机器语言
    },
    methods: {
        /**
         * @description: 点击空白关闭当前页
         * @param {*} 
         * @return {*}
         * @author: jinchuan.lee
         */        
        showSetting() {
            if(!this.isStop) {
                this.isSettingFieldShow = false;
            }
        },
        /**
         * @description: 鼠标静止2s钟关闭当前页
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        staticClose() {
            clearTimeout(this.closeTime);
            this.closeTime = setTimeout(()=>{
                if(!this.isStop) {
                    this.isSettingFieldShow = false;
                }
            },2000)
        },
        /**
         * @description: 添加&&移出全局点击事件
         * @param {Boolean} status true添加 false移出
         * @return {*}
         * @author: jinchuan.lee
         */        
        addWindClick(status) {
            if(status) {
                window.addEventListener('click',this.showSetting);
                window.addEventListener('mousemove',this.staticClose);
            }else {
                window.removeEventListener('click',this.showSetting);
                window.removeEventListener('mousemove',this.staticClose);
            }
        },
        /**
         * @description: 第一次进来提示语
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        getFirstGoin() {
            setTimeout(()=>{
                this.getAiSay();
                this.isAiSay = true;
            },500)
            setTimeout(()=>{
                this.isAiSay = false;
            },4000)
        },
        // 获取机器语言
        getAiSay() {
            // 随机数字
            var num = Math.floor(Math.random() * this.AiSay.length);
            this.aiContent = this.AiSay[num];
            // 删除当前话
            this.AiSay.splice(num,1);
            if(!this.AiSay.length) {
                console.log('已经轮完了')
                this.AiSay = this.$lodash.cloneDeep(this._AiSay)
            }
        },
        /**
         * @description: 请求字典
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        getDictionaries() {
            // 日期字典表
            this.$http.post('sys/dict/list' , {type:"cross_analysis_date"}).then(res=>{
                if(res&&res.data.code==1){
                    this.dateList = res.data.data;
                    this.dateList.push({
                        description: "交叉分析",
                        id: "666666",
                        label: "全部",
                        sort: 1,
                        type: "cross_analysis_date",
                        value: ""
                    })
                }
            }) 

            // 数值字典表
            this.$http.post('sys/dict/list' , {type:"cross_analysis_value"}).then(res=>{
                if(res&&res.data.code==1){
                    this.numberList = res.data.data;
                }
            })

        },
        /**
         * @description: 修改赋值
         * @param {*} id 修改的tabID
         * @return {*}
         * @author: jinchuan.lee
         */        
        setData(id) {
            this.$http.post('analysis/findAnalysisContent' , {id:id}).then(res=>{
                if(res&&res.data.code==1){
                    this.rowList = res.data.data.row;
                    this.columnList = res.data.data.column;
                    this.valueList = res.data.data.value;
                    this.$refs.columnDom.dataList =res.data.data.column;
                    this.$refs.rowDom.dataList = res.data.data.row;
                    this.$refs.valueDom.dataList = res.data.data.value;
                }
            })
        },
        /**
         * @description: 获取所有数据函数
         * @param {*}
         * @return {Object} params 所有数据对象
         * @author: jinchuan.lee
         */        
        getRequestData() {
            let params = {
                data:{
                    columns: this.columnList,
                    rows: this.rowList,
                    values: this.valueList,
                },
                status:true
            }
            return params;
        },
        /**
         * @description: 清空所有数据
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        clearData() {
            console.log("清空数据")
            this.columnList = [];
            this.rowList = [];
            this.valueList = [];
            this.$refs.columnDom.dataList = [];
            this.$refs.rowDom.dataList = [];
            this.$refs.valueDom.dataList = [];
        },
        /**
         * @description: 判断是否可以拖入总函数
         * @param {*} data 按住的字段参数
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleItemHold(data) {
            let idText = data.id; 
            if(idText === "columnList") {
                this.handleRowPrevent(data,'own');
                this.handleValuePrevent(data);
            }else if(idText === "rowList") {
                this.handleColumnPrevent(data,'own');
                this.handleValuePrevent(data);
            }else if(idText === "valueList") {
                this.handleColumnPrevent(data);
                this.handleRowPrevent(data);
            }else {
                this.handleColumnPrevent(data);
                this.handleRowPrevent(data);
                this.handleValuePrevent(data);
            }
            this.isHoldTime = data.isHold;
            if(data.isHold) {
                this.isSettingFieldShow = true;
                this.isStop = true;
                clearTimeout(this.fadeTime);
               
            }else {
                this.aiThink(2000);
            }
        },
        /**
         * @description: 机器人动画
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        aiThink(time) {
            this.$refs.canvasBgRef.running();  // 执行动画
            this.showAiThink = true;
            clearTimeout(this.canvasBgTime);
            this.canvasBgTime = setTimeout(()=>{
                this.showAiThink = false;
                this.$refs.canvasBgRef.stopRun();  // 停止动画
            },time)
        },
        /**
         * @description: 鼠标移入
         * @param {*} e
         * @return {*}
         * @author: jinchuan.lee
         */        
        settingFieldEnter(e) {
            clearTimeout(this.fadeTime);
        },
        /**
         * @description: 鼠标移出消失
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        settingFieldLeave(e) {
            let currTargetEl = e.relatedTarget || e.toElement;
            let targetClassName = currTargetEl?currTargetEl.className:"";
            let isLeaveSelect = (targetClassName.indexOf('el-select-dropdown') !== -1) || (targetClassName.indexOf('el-popper') !== -1) || (targetClassName.indexOf('popper__arrow') !== -1) || (targetClassName.indexOf('el-scrollbar__bar') !== -1) 
            if(this.isHoldTime || isLeaveSelect) {
                this.isSettingFieldShow = true;
                return 
            }
            this.fadeTime = setTimeout(()=>{
                if(!this.isStop) {
                    this.isSettingFieldShow = false;
                }
            },500)
        },
        /**
         * @description: 下拉框改变重新请求
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleSelectChange() {
            // 实时请求
            let queryData = this.getRequestData();
            this.$emit("previewTableData",queryData);
        },
        /**
         * @description: 拖动改变  请求接口
         * @param {*} data
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleChange(data) {
            this[data.id] = data.list;
            // 实时请求
            let queryData = this.getRequestData();
            let listObj = queryData.data;
            if(!listObj.columns.length && !listObj.rows.length && !listObj.values.length) {  // 如果都为空  则关闭自动关闭
                this.isStop = true;
            }else {
                 this.isStop = false;
            }
            this.$emit("previewTableData",queryData);
        },
        /**
         * @description: 阻止当前组件拖入函数
         * @param {String} refName 组件的ref名称
         * @param {Boolean} type 是否可以拖入
         * @return {*}
         * @author: jinchuan.lee
         */        
        preventPut(refName,type) {
            let refDom = this.$refs[refName];
            refDom.dragConfig.put = !type;
        },
        /**
         * @description: 
         * @param {String} type 1、列；2、行；3、值
         * @param {String} text  提示文本
         * @param {Boolean} status  是否显示提示禁用
         * @return {*}
         * @author: jinchuan.lee
         */        
        preventSetting(type,text,status) {
            switch(type) {
                case "1":
                    this.columnModelText = text;
                    this.isShowColumnModel = status;
                    this.preventPut("columnDom",status);
                    break;
                case "2":
                    this.rowModelText = text;
                    this.isShowRowModel = status;
                    this.preventPut("rowDom",status);
                    break;
                case "3":
                    this.valueModelText = text;
                    this.isShowValueModel = status;
                    this.preventPut("valueDom",status);
                    break;
            }
        },
        /**
         * @description: 判断列是否可以拖入
         * @param {Object} data 当前拖入对象信息
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleColumnPrevent(data,status) {
            if(!data.isHold) {
                this.preventSetting("1","",false)
                return;
            };
            // 判断是否重复，包括行和自己都不能有相同的字段
            let text,isPrevent = false;
            let isOwnItem = this.columnList.some(i => i.name == data.itemName);
            let isRowItem = this.rowList.some(i => i.name == data.itemName);
            if(isOwnItem) {  // 自己已存在
                text = data.itemName + "已存在";
                isPrevent = true;
            }
            if(isRowItem && status !== 'own') {  // 行中已存在
                text = "行：" + data.itemName + "已存在";
                isPrevent = true;
            }
            if(this.columnList.length >= 3) {  // 判断是否超出限制
                text = "超出列限制";
                isPrevent = true;
            }
            if(isPrevent) {
                this.preventSetting("1",text,true);
            }else {
                this.preventSetting("1","",false);
            }
        },
        /**
         * @description: 判断行是否可以拖入
         * @param {Object} data 当前拖入对象信息
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleRowPrevent(data,status) {
             if(!data.isHold) {
                this.preventSetting("2","",false)
                return;
            };
            // 判断是否重复，包括行和自己都不能有相同的字段
            let text,isPrevent = false;
            let isOwnItem = this.rowList.some(i => i.name == data.itemName);
            let isRowItem = this.columnList.some(i => i.name == data.itemName);
            if(isOwnItem) {  // 自己已存在
                text = data.itemName + "已存在";
                isPrevent = true;
            }
            if(isRowItem && status !== 'own') {  // 行中已存在
                text = "列：" + data.itemName + "已存在";
                isPrevent = true;
            }
            if(this.rowList.length >= 3) {  // 判断是否超出限制
                text = "超出列限制";
                isPrevent = true;
            }
            if(isPrevent) {
                this.preventSetting("2",text,true);
            }else {
                this.preventSetting("2","",false);
            }
        },
        /**
         * @description: 判断值是否可以拖入
         * @param {Object} data 当前拖入对象信息
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleValuePrevent(data) {
            if(!data.isHold) {
                this.preventSetting("3","",false)
                return;
            };
            let text,isPrevent = false;
            let isOwnItem = this.valueList.some(i => i.name == data.itemName);
            if(data.customtype != '3' && isOwnItem) {  // 不是数值类型的字段不可以重复
                text = data.itemName + "已存在";
                isPrevent = true;
            }
            if(isPrevent) {
                this.preventSetting("3",text,true);
            }else {
                this.preventSetting("3","",false);
            }
        }
    }
}
</script>
<style lang="less" scoped>
    .c-settingField {
        position: absolute;
        top: 0;
        left: 0;
        background: #fff;
        width: calc(100% - 3.8rem);
        height: 100%;
        z-index: 1500;
        &-preventModel {
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            top: 0;
            left: 0;
            z-index: 1502;
            span {
                color: rgb(253, 72, 52);
                position: absolute;
                left: 0;
                top: 50%;
                font-size: .18rem;
                font-weight: 600;
                transform: translateY(-50%);
                width: 100%;
                text-align: center;
            }
        }
        &-columns {
            background: rgba(198, 224, 255, 0.9);
        }
        &-rows {
            background: rgba(252, 227, 213, 0.9);
        }
        &-values {
            background: rgba(218, 248, 239, 0.9);
        }
        &-describe {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
        	/*AI动画*/
        @keyframes shake {
            0%,100% {
            transform: translateX(0);
            }
            10%,30%,50%,70%,90% {
            transform: translateX(-2px);
            }
            20%,40%,60%,80%,{
            transform: translateX(2px);
            }
        }
        &-row {
            height: 1.8rem;
            &-aiwrapper {
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                &-content {
                    position: absolute;
                }
                &-AI {
                    width: 70px;
                    height: 70px;
                    cursor: pointer;
                    transition: all .2s;
                    display: inline-block;
                    user-select: none;
                    &:hover {
                    animation: shake 1s;
                    }
                }
            }
            &-left {
                width: 2.42rem;
                border: 1px dashed @main-color;
                height: 100%;
                float: left;
                position: relative;
                box-sizing: border-box;
                overflow: auto;
            }
            &-right {
                width: calc(100% - 2.5rem);
                border: 1px dashed @main-color;
                height: 100%;
                float: right;
                position: relative;
                box-sizing: border-box;
                overflow: auto;
            }
            &:last-child {
                height: calc(100% - 1.87rem);
                margin-top: 0.07rem;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/cashier/components/crossAnalysis/settingField.vue